import React from 'react';
import { theme } from 'styles';

interface Props {
  title: string;
  subText?: string;
}

function BoxTitle({ title, subText }: Props) {
  return (
    <h2
      css={{
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: 1.4,
        color: theme.color.text,
      }}
    >
      {title}{' '}
      {subText ? (
        <small
          css={{ fontSize: 14, fontWeight: 400, color: theme.color.textMuted }}
        >
          {subText}
        </small>
      ) : null}
    </h2>
  );
}

export default BoxTitle;
